// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ContextMaker$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/ContextMaker.res.mjs";
import * as BadgeTypes$LiteracyplanetSharedClientProfile from "@literacyplanet/shared-client-profile/src/BadgeTypes.res.mjs";

var include = ContextMaker$LiteracyplanetClientFlags.Make({
      name: "BadgesContext"
    });

var Data = BadgeTypes$LiteracyplanetSharedClientProfile.Data;

var stringifyData = BadgeTypes$LiteracyplanetSharedClientProfile.stringifyData;

var parseJsonData = BadgeTypes$LiteracyplanetSharedClientProfile.parseJsonData;

var testAwards = BadgeTypes$LiteracyplanetSharedClientProfile.testAwards;

var initialContext = include.initialContext;

var context = include.context;

var P = include.P;

var Provider = include.Provider;

var ContextMakerProviderNotFound = include.ContextMakerProviderNotFound;

var use = include.use;

export {
  Data ,
  stringifyData ,
  parseJsonData ,
  testAwards ,
  initialContext ,
  context ,
  P ,
  Provider ,
  ContextMakerProviderNotFound ,
  use ,
}
/* include Not a pure module */
